export const language_codes = {
  name: {
    abkhazian: "ab",
    afar: "aa",
    afrikaans: "af",
    akan: "ak",
    albanian: "sq",
    amharic: "am",
    arabic: "ar",
    aragonese: "an",
    armenian: "hy",
    assamese: "as",
    avaric: "av",
    avestan: "ae",
    aymara: "ay",
    azerbaijani: "az",
    bambara: "bm",
    bashkir: "ba",
    basque: "eu",
    belarusian: "be",
    bengali: "bn",
    "bihari languages": "bh",
    bislama: "bi",
    bosnian: "bs",
    breton: "br",
    bulgarian: "bg",
    burmese: "my",
    catalan: "ca",
    chamorro: "ch",
    chechen: "ce",
    chichewa: "ny",
    chinese: "zh",
    chuvash: "cv",
    cornish: "kw",
    corsican: "co",
    cree: "cr",
    croatian: "hr",
    czech: "cs",
    danish: "da",
    divehi: "dv",
    dutch: "nl",
    dzongkha: "dz",
    english: "en",
    esperanto: "eo",
    estonian: "et",
    ewe: "ee",
    faroese: "fo",
    fijian: "fj",
    finnish: "fi",
    french: "fr",
    fulah: "ff",
    galician: "gl",
    georgian: "ka",
    german: "de",
    greek: "el",
    guarani: "gn",
    gujarati: "gu",
    haitian: "ht",
    hausa: "ha",
    hebrew: "he",
    herero: "hz",
    hindi: "hi",
    "hiri motu": "ho",
    hungarian: "hu",
    interlingua: "ia",
    indonesian: "id",
    interlingue: "ie",
    irish: "ga",
    igbo: "ig",
    inupiaq: "ik",
    ido: "io",
    icelandic: "is",
    italian: "it",
    inuktitut: "iu",
    japanese: "ja",
    javanese: "jv",
    kalaallisut: "kl",
    kannada: "kn",
    kanuri: "kr",
    kashmiri: "ks",
    kazakh: "kk",
    "central khmer": "km",
    kikuyu: "ki",
    kinyarwanda: "rw",
    kirghiz: "ky",
    komi: "kv",
    kongo: "kg",
    korean: "ko",
    kurdish: "ku",
    kuanyama: "kj",
    latin: "la",
    luxembourgish: "lb",
    ganda: "lg",
    limburgan: "li",
    lingala: "ln",
    lao: "lo",
    lithuanian: "lt",
    "luba-katanga": "lu",
    latvian: "lv",
    manx: "gv",
    macedonian: "mk",
    malagasy: "mg",
    malay: "ms",
    malayalam: "ml",
    maltese: "mt",
    maori: "mi",
    marathi: "mr",
    marshallese: "mh",
    mongolian: "mn",
    nauru: "na",
    navajo: "nv",
    "north ndebele": "nd",
    nepali: "ne",
    ndonga: "ng",
    "norwegian bokmål": "nb",
    "norwegian nynorsk": "nn",
    norwegian: "no",
    "sichuan yi": "ii",
    "south ndebele": "nr",
    occitan: "oc",
    ojibwa: "oj",
    "church slavic": "cu",
    oromo: "om",
    oriya: "or",
    ossetian: "os",
    punjabi: "pa",
    pali: "pi",
    persian: "fa",
    polish: "pl",
    pashto: "ps",
    portuguese: "pt",
    quechua: "qu",
    romansh: "rm",
    rundi: "rn",
    romanian: "ro",
    russian: "ru",
    sanskrit: "sa",
    sardinian: "sc",
    sindhi: "sd",
    "northern sami": "se",
    samoan: "sm",
    sango: "sg",
    serbian: "sr",
    gaelic: "gd",
    shona: "sn",
    sinhala: "si",
    slovak: "sk",
    slovenian: "sl",
    somali: "so",
    "southern sotho": "st",
    spanish: "es",
    sundanese: "su",
    swahili: "sw",
    swati: "ss",
    swedish: "sv",
    tamil: "ta",
    telugu: "te",
    tajik: "tg",
    thai: "th",
    tigrinya: "ti",
    tibetan: "bo",
    turkmen: "tk",
    tagalog: "tl",
    tswana: "tn",
    tonga: "to",
    turkish: "tr",
    tsonga: "ts",
    tatar: "tt",
    twi: "tw",
    tahitian: "ty",
    uighur: "ug",
    ukrainian: "uk",
    urdu: "ur",
    uzbek: "uz",
    venda: "ve",
    vietnamese: "vi",
    volapük: "vo",
    walloon: "wa",
    welsh: "cy",
    wolof: "wo",
    "western frisian": "fy",
    xhosa: "xh",
    yiddish: "yi",
    yoruba: "yo",
    zhuang: "za",
    zulu: "zu"
  },
  abbr: {
    ab: "Abkhazian",
    aa: "Afar",
    af: "Afrikaans",
    ak: "Akan",
    sq: "Albanian",
    am: "Amharic",
    ar: "Arabic",
    an: "Aragonese",
    hy: "Armenian",
    as: "Assamese",
    av: "Avaric",
    ae: "Avestan",
    ay: "Aymara",
    az: "Azerbaijani",
    bm: "Bambara",
    ba: "Bashkir",
    eu: "Basque",
    be: "Belarusian",
    bn: "Bengali",
    bh: "Bihari languages",
    bi: "Bislama",
    bs: "Bosnian",
    br: "Breton",
    bg: "Bulgarian",
    my: "Burmese",
    ca: "Catalan",
    ch: "Chamorro",
    ce: "Chechen",
    ny: "Chichewa",
    zh: "Chinese",
    cv: "Chuvash",
    kw: "Cornish",
    co: "Corsican",
    cr: "Cree",
    hr: "Croatian",
    cs: "Czech",
    da: "Danish",
    dv: "Divehi",
    nl: "Dutch",
    dz: "Dzongkha",
    en: "English",
    english: "English",
    English: "English",
    eo: "Esperanto",
    et: "Estonian",
    ee: "Ewe",
    fo: "Faroese",
    fj: "Fijian",
    fi: "Finnish",
    fr: "French",
    ff: "Fulah",
    gl: "Galician",
    ka: "Georgian",
    de: "German",
    el: "Greek",
    gn: "Guarani",
    gu: "Gujarati",
    ht: "Haitian",
    ha: "Hausa",
    he: "Hebrew",
    hz: "Herero",
    hi: "Hindi",
    ho: "Hiri Motu",
    hu: "Hungarian",
    ia: "Interlingua",
    id: "Indonesian",
    ie: "Interlingue",
    ga: "Irish",
    ig: "Igbo",
    ik: "Inupiaq",
    io: "Ido",
    is: "Icelandic",
    it: "Italian",
    iu: "Inuktitut",
    ja: "Japanese",
    jv: "Javanese",
    kl: "Kalaallisut",
    kn: "Kannada",
    kr: "Kanuri",
    ks: "Kashmiri",
    kk: "Kazakh",
    km: "Central Khmer",
    ki: "Kikuyu",
    rw: "Kinyarwanda",
    ky: "Kirghiz",
    kv: "Komi",
    kg: "Kongo",
    ko: "Korean",
    ku: "Kurdish",
    kj: "Kuanyama",
    la: "Latin",
    lb: "Luxembourgish",
    lg: "Ganda",
    li: "Limburgan",
    ln: "Lingala",
    lo: "Lao",
    lt: "Lithuanian",
    lu: "Luba-Katanga",
    lv: "Latvian",
    gv: "Manx",
    mk: "Macedonian",
    mg: "Malagasy",
    ms: "Malay",
    ml: "Malayalam",
    mt: "Maltese",
    mi: "Maori",
    mr: "Marathi",
    mh: "Marshallese",
    mn: "Mongolian",
    na: "Nauru",
    nv: "Navajo",
    nd: "North Ndebele",
    ne: "Nepali",
    ng: "Ndonga",
    nb: "Norwegian Bokmål",
    nn: "Norwegian Nynorsk",
    no: "Norwegian",
    ii: "Sichuan Yi",
    nr: "South Ndebele",
    oc: "Occitan",
    oj: "Ojibwa",
    cu: "Church Slavic",
    om: "Oromo",
    or: "Oriya",
    os: "Ossetian",
    pa: "Punjabi",
    pi: "Pali",
    fa: "Persian",
    pl: "Polish",
    ps: "Pashto",
    pt: "Portuguese",
    qu: "Quechua",
    rm: "Romansh",
    rn: "Rundi",
    ro: "Romanian",
    ru: "Russian",
    sa: "Sanskrit",
    sc: "Sardinian",
    sd: "Sindhi",
    se: "Northern Sami",
    sm: "Samoan",
    sg: "Sango",
    sr: "Serbian",
    gd: "Gaelic",
    sn: "Shona",
    si: "Sinhala",
    sk: "Slovak",
    sl: "Slovenian",
    so: "Somali",
    st: "Southern Sotho",
    es: "Spanish",
    su: "Sundanese",
    sw: "Swahili",
    ss: "Swati",
    sv: "Swedish",
    ta: "Tamil",
    te: "Telugu",
    tg: "Tajik",
    th: "Thai",
    ti: "Tigrinya",
    bo: "Tibetan",
    tk: "Turkmen",
    tl: "Tagalog",
    tn: "Tswana",
    to: "Tonga",
    tr: "Turkish",
    ts: "Tsonga",
    tt: "Tatar",
    tw: "Twi",
    ty: "Tahitian",
    ug: "Uighur",
    uk: "Ukrainian",
    ur: "Urdu",
    uz: "Uzbek",
    ve: "Venda",
    vi: "Vietnamese",
    vo: "Volapük",
    wa: "Walloon",
    cy: "Welsh",
    wo: "Wolof",
    fy: "Western Frisian",
    xh: "Xhosa",
    yi: "Yiddish",
    yo: "Yoruba",
    za: "Zhuang",
    zu: "Zulu"
  }
};
